import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme: any) => ({
  iconSize: {
    padding: 0, fontSize: 22
  }
}));

type ActionButtonProps = {
  shouldCollapse?: boolean;
  handleCollapse?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleAdd?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleEdit?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleDelete?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  disableDelete?: boolean;
  handleChain?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleParties?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleTaxable?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleIndividualPayeePayer?: React.MouseEventHandler<HTMLButtonElement> | undefined;
};

const Actionbuttons = ({
  shouldCollapse,
  handleCollapse,
  handleAdd,
  handleEdit,
  handleDelete,
  handleChain,
  handleParties,
  handleTaxable,
  handleIndividualPayeePayer,
  disableDelete
}: ActionButtonProps) => {
  const classes = useStyles();
  return (
    <Box
      style={{ display: 'flex', justifyContent: 'space-around', flexDirection: 'row', gap: '2px' }}
    >
      {handleCollapse && (
        <IconButton className={classes.iconSize} onClick={handleCollapse} size="large">
          {shouldCollapse ? (
            <FontAwesomeIcon icon="arrow-alt-circle-up" size="xs" />
          ) : (
            <FontAwesomeIcon icon="arrow-alt-circle-down" size="xs" />
          )}
        </IconButton>
      )}
      {handleAdd && (
        <IconButton className={classes.iconSize} onClick={handleAdd} size="large">
          <FontAwesomeIcon icon="plus-circle" size="xs" />
        </IconButton>
      )}
      {handleEdit && (
        <IconButton className={classes.iconSize} onClick={handleEdit} size="large">
          <FontAwesomeIcon icon="edit" size="xs" />
        </IconButton>
      )}
      {handleDelete && (
        <IconButton
          disabled={disableDelete}
          className={classes.iconSize}
          onClick={handleDelete}
          size="large"
        >
          <FontAwesomeIcon icon="trash" size="xs" />
        </IconButton>
      )}
      {handleChain && (
        <IconButton className={classes.iconSize} onClick={handleChain} size="large">
          <FontAwesomeIcon icon="link" size="xs" />
        </IconButton>
      )}
      {handleParties && (
        <IconButton className={classes.iconSize} onClick={handleParties} size="large">
          <FontAwesomeIcon icon="people-arrows" size="xs" />
        </IconButton>
      )}
      {handleTaxable && (
        <IconButton className={classes.iconSize} onClick={handleTaxable} size="large">
          <FontAwesomeIcon icon="coins" size="xs" />
        </IconButton>
      )}
      {handleIndividualPayeePayer && (
        <IconButton
          className={classes.iconSize}
          onClick={handleIndividualPayeePayer}
          size="large"
        >
          <FontAwesomeIcon icon="user" size="xs" />
        </IconButton>
      )}
    </Box>
  );
};

export default Actionbuttons;
